<template>
  <div class="row">
    <div class="col-12 col-sm-3 col-lg-2 sidebarContainer">
      <AlgoliaSidebar />
    </div>
    <div class="col-12 col-sm-9 col-lg-10">
      <!-- TODO Style sort by for search page and make it look nice -->
      <ais-sort-by
        :items="sortOptions"
      >
        <ul class="searchOrdering" slot-scope="{ items, currentRefinement, refine }">
          <li>Sort By:</li>
          <li v-for="item in items" :key="item.value" :value="item.value">
            <a
              href="#"
              :style="{ textDecoration: item.value === currentRefinement ? 'underline' : '' }"
              @click.prevent="() => {currentOption = item.value; refine(item.value)}"
            >
              {{ item.label }}
            </a>
          </li>
        </ul>
      </ais-sort-by>
      <ais-infinite-hits
        :transform-items="transform"
      >
        <div class="row" slot-scope="{ items, refineNext, isLastPage}">
          <!-- Show all the items on a page -->
          <ListItem
            v-for="item in items"
            :item="item"
            :key="item.id"
            :source="'search'"
            class="col-12 col-md-4 col-lg-3"
          />
          <div class="col-12 text-center my-4" v-if="items.length==0">
            <h1 class="h3 col-12">No Items Match that Search</h1> <!--Text for no results-->
            <p class="col-8 mx-auto">This item is currently not loaded on our website. Please use the ‘<router-link :to="{name: 'get-a-price'}">Request Price</router-link>’ button to submit your request and our quotes team will get back to you with a price and availability shortly</p>
          </div>
          <!-- Button to load more items shown after items rendered on page -->
          <div v-else class="col-12 my-3 text-center">
            <button
              slot="loadMore"
              @click="refineNext"
              :disabled="isLastPage"
              class="btn-more-items btn btn-primary"
            >
              Show more results
            </button>
          </div>
        </div>
      </ais-infinite-hits>
    </div>
    <vue-headful
      :title="$route.query.s ? $route.query.s + ' - Search | Cherrytree' : 'Search | Cherrytree'"
    />
  </div>
</template>

<script>
import { AisInfiniteHits, AisSortBy } from "vue-instantsearch";

import {mapState} from 'vuex'

import ListItem from "../shop/listing/ListItem";

import AlgoliaSidebar from "./AlgoliaSidebar";

import { filterListing } from "../shop/listing/filterListing";

import { fetchBrands } from "../../network/brandRequests";

import { titleCase } from "@/utils";

export default {
  name: "SearchResults",
  components: {
    ListItem,
    AisInfiniteHits,
    AlgoliaSidebar,
    AisSortBy
  },
  data() {
    return {
      results: null,
      loading: true,
      sortOptions:[
        {value: 'ct_live_products', label:'Most Relevant'},
        {value: 'ct_live_products_price_ascending', label: 'Lowest Price'},
        {value: 'ct_live_products_price_descending', label: 'Highest Price'}
      ],
      currentOption: 'ct_live_products',
      brands: null
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      fetchBrands(
        brands => {
          this.brands = brands;
        },
        err => {
          console.log(err);
        }    
      )
      // NOTE: Potentially an artifact for how it used to be done before Algolia was introduced
      // todo search page load with no query
      //   this.loading = true;
      //   fetchSearchResults(
      //     { query: this.$route.query.s },
      //     results => {
      //       // todo remove filter when trev has fixed backend
      //       this.results = Object.values(results).filter(result => result.id); //convert to array and remove things that aren't products
      //       this.loading = false;
      //       try{
      //         if (results.length === 0){
      //           //Send google analytics event for search with no results
      //           this.$ga.event('Search', 'No Results', this.$route.query.s); //send event
      //         }else if(results.length < 5){
      //           this.$ga.event('Search', 'Less than 5 results', this.$route.query.s); //send event
      //         }
      //       }catch (error){
      //         console.log("error sending search no results event ", error)
      //       }
      //     },
      //     error => {
      //       // todo check 0 results don't fall through here
      //       this.loading = false;
      //       this.results = [];
      //     }
      //   );
    },
    transform(items){
      let filtered = []
      let showSupressed = !(this.memberLevel == 'silver' || this.memberLevel =='public' || this.memberLevel == null || this.memberLevel=='null')
      for(let item of items){
        if(this.currentOption == "ct_live_brands" && this.brands != null) {
          for(let [_key, brand] of Object.entries(this.brands)) {
            if(item.title.toLowerCase().includes(brand.title.toLowerCase()) || brand.title.toLowerCase().includes(item.title.toLowerCase())) {
              item.images = brand.images;
              item.id = brand.id;
            } 
          }
        }


        if(item.product_code && item.product_code.includes("_info") || this.currentOption == "ct_live_brands") {
          item.is_brand = true;
          // console.log(item)
          if(item.title == "") {
            item.title = titleCase(item.product_code.substr(0, item.product_code.length-5).replace("_"," "));
          }
        }

        if( (item["supressed"] == "yes" && showSupressed) || !item["supressed"] || item["supressed"] == "no"){
          if(!item.title) {
            item.title = item.exonet_title
          }
          filtered.push(item)
        }

      }
      return filtered
    }
  },
  watch: {
    $route(to, from) {
      if (to.query.s !== from.query.s) {
        this.loadData();
      }
    }
  },
  computed: {
    ...mapState({
      memberLevel: state => state.auth.memberLevel
    }),
    sorted() {
      if (!this.results) return [];
      return this.results
        .slice()
        .sort((a, b) => a.page_relevance > b.page_relevance);
    },
    products() {
      if (!this.results) return [];
      //filter results where no product is found for result, happens when search index is out of date
      return this.results
        .map(result => result.product)
        .filter(product => !Array.isArray(product));
    },
    filteredProducts() {
      if (!this.filtered) return [];
      return this.filtered.map(result => result.product);
    },
    //filtered search results
    filtered() {
      let { priceHigh, priceLow, brand, refine } = this.$route.query;
      let search = null;
      let price_key = "member_price";

      return filterListing(
        this.sorted,
        priceHigh,
        priceLow,
        brand,
        refine,
        search,
        "product",
        price_key
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.result {
  padding-top: 20px;
  strong {
    font-weight: normal;
    background: red;
  }
}

.btn-more-items{
  &:disabled{
    display: none;
  }
}

.searchOrdering{
  list-style: none;
  height: 24px;
  padding-top: 13px;
  & li{
    display: inline-block;
    margin-right: 20px;
    & a{
      color: #333;
      &:hover{
        color: $CTred;
      }
    }
  }
}

@include media-breakpoint-down(sm){
  .searchOrdering{
    height: auto;
    & li{
      display: list-item;
    }
  }
}
</style>
